import { BacksolveApproach, ValuationsApproach } from 'common/types/valuation';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import reverseParser from 'pages/Valuations/approaches/backsolveApproach/BacksolveTable/util/reverseParser';
import { BACKSOLVE_TABLE_NAMES } from 'pages/Valuations/approaches/backsolveApproach/constants';
import parser from 'pages/Valuations/approaches/backsolveApproach/MarketAdjustmentTable/util/parser';
import rowConfig from 'pages/Valuations/approaches/backsolveApproach/MarketAdjustmentTable/util/rowConfig';
import tableValidations from 'pages/Valuations/approaches/backsolveApproach/MarketAdjustmentTable/util/tableValidations';
import { PUBLIC_COMPANIES } from 'pages/Valuations/util/constants';
import { getApproachTableName } from 'pages/ValuationsAllocation/util';
import { getDefaultCompsApproachForDropdown } from 'pages/ValuationsAllocation/util/getDefaultCompsApproachForDropdown';
import { getStringValue, shortDate } from 'utilities';
import { CreateMarketAdjustmentTableProps } from './types';
import { ExtendedValuationApproachModel } from '../types';
import afterCellsChanged from './util/afterCellsChanged';

const createMarketAdjustmentData = ({
  approach,
  approaches,
  backsolveSummarySheet,
  attrs,
  isDisabled,
}: CreateMarketAdjustmentTableProps) => {
  const name = getApproachTableName({
    approach: approach as unknown as ValuationsApproach,
    tableSuffix: BACKSOLVE_TABLE_NAMES.MARKET_ADJUSTMENT,
  });

  const asOfDate = getStringValue(shortDate(approach?.valuations_approach_backsolve?.as_of_date));

  const column = approach.valuations_approach_backsolve as unknown as BacksolveApproach;
  const defaultApproach = getDefaultCompsApproachForDropdown(approaches, [PUBLIC_COMPANIES]);
  column.gpc_approach = column.gpc_approach ?? defaultApproach?.valuations_approach_gpc?.id;
  column.valuation_approach_gpc = column.gpc_approach as number;

  column.as_of_date = asOfDate;
  const savedPublicCompStatusIds
    = approach.valuations_approach_backsolve?.public_companies_status?.map(({ id }) => id) || [];

  const getColumns = () => [{}, column];
  const getRowConfig = () =>
    rowConfig(
      approach,
      approaches as unknown as ExtendedValuationApproachModel[],
      backsolveSummarySheet.name as string,
      isDisabled
    );

  return new SpreadsheetConfig({
    name,
    parser,
    reverseParser: reverseParser as unknown as SpreadsheetConfig['reverseParser'],
    rowConfig: getRowConfig(),
    tableData: {
      approach,
      approaches,
      isDisabled,
      savedPublicCompStatusIds,
      backsolveSummarySheetName: backsolveSummarySheet.name,
    },
    afterCellChanged: afterCellsChanged as unknown as SpreadsheetConfig['afterCellChanged'],
    columns: getColumns(),
    showTitlesColumn: false,
    showToolbar: true,
    fieldAttributes: attrs,
    customValidations: tableValidations as unknown as SpreadsheetConfig['customValidations'],
    displayRowIndicator: false,
    displayColumnIndicator: false,
    getColumns,
    format: undefined,
    currencyFormatter: false,
    unitsFormatter: false,
    totalParser: undefined,
  });
};

export default createMarketAdjustmentData;
